import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

/**
 * Small GDPR notice shown above the submit button of every form that
 * collects personal data. Meets UK GDPR transparency requirements by
 * pointing to the Privacy Policy at the point of collection.
 */
const GdprNotice = ({ testId = 'gdpr-notice' }) => (
  <div
    className="flex items-start gap-2 rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-[11px] leading-relaxed text-slate-600"
    data-testid={testId}
  >
    <ShieldCheck className="w-3.5 h-3.5 text-[#1e3a5f] shrink-0 mt-0.5" />
    <span>
      By submitting this form you agree to Abney Low Nursing Home processing your details in order
      to respond to your request. See our{' '}
      <Link
        to="/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#1e3a5f] underline underline-offset-2 hover:text-[#c9a227] font-semibold"
      >
        Privacy Policy
      </Link>{' '}
      for details of how we use your data and your rights under the UK GDPR.
    </span>
  </div>
);

export default GdprNotice;
